<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/account/mydogs"></ion-back-button>
    </ion-buttons>
    <ion-title>{{title}}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content color="lightmimbo">
  <div class="ion-padding ion-text-center" *ngIf="isLoading">
    <ion-spinner color="primary"></ion-spinner>
  </div>
  <div *ngIf="!isLoading">
    <form #f="ngForm" class="ion-padding">
      <ion-grid>
        <ion-row>
          <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
            <ion-avatar class="avatar-img" (click)="setOpen()">
              <img [src]="uploadedImage" width="120px" />
              <ion-icon name="add-circle" color="darkmimbo"></ion-icon>
            </ion-avatar>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
            <ion-list>
              <ion-item color="lightmimbo">
                <ion-input name="dogname" [(ngModel)]="name" label="Pet Name*" labelPlacement="floating" required
                  dogname maxlength="40" #dognameCtrl="ngModel"></ion-input>
              </ion-item>
              <ion-item color="lightmimbo">
                <ion-select label="Pet Type*" label-placement="floating" [value]="this.petType"
                  (ionChange)="setPetType($event)">
                  <ion-select-option value="1">Dog</ion-select-option>
                  <ion-select-option value="2">Cat</ion-select-option>
                </ion-select>
              </ion-item>
              <ion-item color="lightmimbo">
                <div class="input-with-icon">
                  <ion-input name="breed" [(ngModel)]="breed" label="Breed*" labelPlacement="floating" required
                    maxlength="40" #breedCtrl="ngModel" id="breed-modal"></ion-input>
                  <ion-icon (click)=" selectBreed()" name="ellipsis-horizontal-circle-outline"
                    class="select"></ion-icon>
                </div>
              </ion-item>
              <ion-item color="lightmimbo">
                <ion-select label="Gender*" label-placement="floating" [value]="this.gender"
                  (ionChange)="setGender($event)">
                  <ion-select-option value="Female">Female</ion-select-option>
                  <ion-select-option value="Male">Male</ion-select-option>
                </ion-select>
              </ion-item>

              <ion-item color="lightmimbo" button="true" id="dob-modal">
                <ion-input name="dob" required label="Date of Birth*" labelPlacement="floating" readonly="true"
                  [(ngModel)]="dob" #dobCtrl="ngModel"></ion-input>
              </ion-item>
              <ion-item color="lightmimbo">
                <ion-checkbox name="castrated" [(ngModel)]="isCastrated"
                  #castratedCtrl="ngModel">Spayed/Neutered</ion-checkbox></ion-item>
            </ion-list>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col sizeMd="8" offsetMd="2" sizeXl="6" offsetXl="3" class="ion-text-center">
            <ion-button color="primary" type="submit" (click)="save()" class="button-width"
              [disabled]="!f.valid"><ion-icon name="save" slot="start"></ion-icon>Save</ion-button>
          </ion-col>
        </ion-row>
        <ion-row *ngIf="dogId>0">
          <ion-col sizeSm="8" offsetSm="2" class="ion-text-center">
            <ion-button color="primary" type="button" class="button-width" color="danger"
              (click)="deleteDog()"><ion-icon name="trash-outline" slot="start"></ion-icon>Delete
            </ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>
    </form>

    <ion-modal trigger="dob-modal" #dobpopup (willDismiss)="onDOBWillDismiss($event)">
      <ng-template>
        <ion-header>
          <ion-toolbar color="primary">
            <ion-buttons slot="start">
              <ion-button (click)="cancelDOB()"><ion-icon name="arrow-back-outline" slot="icon-only">
                </ion-icon></ion-button>
            </ion-buttons>
            <ion-title>Date of Birth</ion-title>
          </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding" color="lightmimbo">
          <div class="calendar">
            <ion-datetime presentation="date" [max]="dateToday" [(ngModel)]="dobPopupVal" color="primary"
              class="calendar"></ion-datetime>
            <ion-button (click)="setDOB()"><ion-icon name="calendar-outline" slot="start"></ion-icon>Set
              Date</ion-button>
          </div>
        </ion-content>
      </ng-template>
    </ion-modal>
  </div>
</ion-content>
<ion-backdrop *ngIf="showImage" (ionBackdropTap)="closeImage()"> </ion-backdrop>
<img [src]="uploadedImage" class="fullscreen-image" *ngIf="showImage" (click)="closeImage()" />